module.exports = __webpack_public_path__ + "static/media/4cirqueduceleste2.649b695a.jpg";